export default __webpack_public_path__ + "static/media/DSC08790.f311db0e.jpg";